
import React from 'react';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';
import { useIsMobile } from '@/hooks/use-mobile';
import { ScrollArea } from '@/components/ui/scroll-area';

interface PageLayoutProps {
  children: React.ReactNode;
  title: string;
  logo?: string;
  colorScheme?: string;
  showBackButton?: boolean;
  backButtonPath?: string;
  renderMenuButton?: () => React.ReactNode;
  className?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  title,
  logo,
  colorScheme = "bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600",
  showBackButton = true,
  backButtonPath = '/',
  renderMenuButton,
  className = "",
}) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-indigo-50 via-purple-50 to-pink-50">
      <NavBar
        title={title}
        logo={logo}
        colorScheme={colorScheme}
        showBackButton={showBackButton}
        backButtonPath={backButtonPath}
        renderMenuButton={renderMenuButton}
      />
      
      <main className={`flex-1 container mx-auto px-3 sm:px-4 py-4 pb-20 ${className}`}>
        {isMobile ? (
          <ScrollArea className="h-[calc(100vh-150px)] overflow-y-auto">
            <div className="pb-16 animate-fade-in">
              {children}
            </div>
          </ScrollArea>
        ) : (
          <ScrollArea className="h-[calc(100vh-150px)] overflow-y-auto">
            <div className="animate-fade-in">
              {children}
            </div>
          </ScrollArea>
        )}
      </main>
      
      <Footer />
    </div>
  );
};

export default PageLayout;
